document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const nav = document.querySelector('[data-mobile-nav]');
      const open = nav && nav.classList.toggle('open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variantSelect = form.querySelector('[name="id"]');
    const price = form.querySelector('[data-product-price]');
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      if (!button) return;
      const original = button.textContent;
      button.disabled = true;
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('cart');
        button.textContent = '✓ Hinzugefügt';
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } catch (error) {
        button.textContent = 'Bitte erneut versuchen';
      }
      window.setTimeout(() => { button.textContent = original; button.disabled = false; }, 1800);
    });
  });

  document.addEventListener('cart:updated', async () => {
    try {
      const cart = await fetch('/cart.js').then((response) => response.json());
      document.querySelectorAll('[data-cart-count]').forEach((item) => { item.textContent = cart.item_count; });
    } catch (error) {}
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const form = root.querySelector('[data-product-form]');
    const data = root.querySelector('[data-product-variants]');
    if (!form || !data) return;
    const variants = JSON.parse(data.textContent || '[]');
    const optionSelects = Array.from(form.querySelectorAll('[data-option-index]'));
    const idInput = form.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const submit = form.querySelector('[type="submit"]');
    const stickyId = document.querySelector('[data-sticky-variant-id]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const stickySubmit = document.querySelector('[data-sticky-submit]');
    const stickyTitle = document.querySelector('[data-sticky-variant-title]');
    const money = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' });
    const updateVariant = () => {
      const choices = optionSelects.map((select) => select.value);
      const variant = variants.find((item) => item.options.every((option, index) => option === choices[index]));
      if (!variant) return;
      idInput.value = variant.id;
      if (price) price.textContent = money.format(variant.price / 100);
      if (submit) { submit.disabled = !variant.available; submit.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft'; }
      if (stickyId) stickyId.value = variant.id;
      if (stickyPrice) stickyPrice.textContent = money.format(variant.price / 100);
      if (stickyTitle) stickyTitle.textContent = variant.title;
      if (stickySubmit) { stickySubmit.disabled = !variant.available; stickySubmit.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft'; }
      optionSelects.forEach((select, index) => { const label = root.querySelector(`[data-option-label-${index}]`); if (label) label.textContent = select.value; });
      if (history.replaceState) history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
    };
    optionSelects.forEach((select) => select.addEventListener('change', updateVariant));
    form.querySelector('[data-qty-minus]')?.addEventListener('click', () => { const qty = form.querySelector('[name="quantity"]'); qty.value = Math.max(1, Number(qty.value) - 1); });
    form.querySelector('[data-qty-plus]')?.addEventListener('click', () => { const qty = form.querySelector('[name="quantity"]'); qty.value = Number(qty.value) + 1; });

    const stickyBar = document.querySelector('[data-sticky-product-bar]');
    const mainBuy = root.querySelector('[data-main-buy]');
    if (stickyBar && mainBuy) {
      const mobileSticky = window.matchMedia('(max-width: 760px)');
      const updateSticky = () => {
        const visible = mobileSticky.matches || mainBuy.getBoundingClientRect().bottom < 88;
        stickyBar.classList.toggle('is-visible', visible);
        stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      };
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
      mobileSticky.addEventListener('change', updateSticky);
      updateSticky();
    }
  });

  document.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const target = document.querySelector(thumb.dataset.target);
      if (!target) return;
      document.querySelectorAll('[data-gallery-image]').forEach((image) => image.classList.remove('active'));
      document.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.remove('active'));
      target.classList.add('active');
      thumb.classList.add('active');
    });
  });
});
